module.exports = __webpack_public_path__ + "img/banner.f73da8a8.png";